module.exports = __webpack_public_path__ + "media/public/img/san-diego-zoo-logo-eb3dd45a927bbc5eec632a786d6e5947.svg";